export default "__VITE_ASSET__CjoD_X6b__";